import { AI_TIERS } from "./aiTiersCatalog";

/** Partner credit pool marketing + dashboard copy. */

export const PARTNER_POOL_SECTION = {
  badge: "AGENCY CREDIT POOL",
  headline: "One shared pool.",
  headlineAccent: "Every client contributes.",
  subhead:
    "Credits from all deployed clients roll into a single agency pool. Heavy users draw from unused capacity elsewhere — you pay for total usage, not wasted per-client silos.",
  footnote: AI_TIERS[0].credits
    ? "Live pool tracking in Partner Console — aggregate billing period usage across your roster."
    : "",
};

export const PARTNER_POOL_BULLETS = [
  {
    title: "Aggregate limit",
    body: "Pool size = sum of each client's tier credits (e.g. 10× Tier 1 = 1,000 credits).",
  },
  {
    title: "Fair-use per client",
    body: "Each client has a soft cap at their tier. Over-cap usage is allowed while the agency pool has headroom.",
  },
  {
    title: "Burst capacity",
    body: "One client at 180 credits and nine at 60 still fits a 1,000-credit pool (780 total used).",
  },
];

export const PARTNER_POOL_EXAMPLE = {
  clientCount: 10,
  tierCreditsEach: AI_TIERS[0].credits,
  poolIncluded: 1000,
  poolUsed: 780,
  heavyClient: { label: "Client A", used: 180, included: 100 },
  lightClients: { count: 9, usedEach: 60, includedEach: 100 },
};

export const PARTNER_POOL_CALLOUT = {
  headline: "Agency Credit Pool",
  insight:
    "Deploy clients at different tiers. Usage aggregates in real time. When a client needs more capacity, upgrade their tier from the Partner Console.",
};

export const computePoolUsagePercent = (used, included) =>
  included > 0 ? Math.min(Math.round((used / included) * 100), 100) : 0;
